import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Table from 'react-bootstrap/Table';
import MoreInfoTables, { requests, tables } from './Tables/MoreInfoTables';
import fig_changes_in_s3q15 from './Figures/change-in-s3q15.png'
import fig_proactive from './Figures/proactive.png'

class InnerPostOperativeRankings extends Component {
    render () {
        return (
          <div>
            <p>
              The SSQ-49 questionnaire measures subjective hearing performance across several dimensions such as directionality of sound, comprehension of speech and quality of sound [20]. Subject data of the Registry (contributing 412 subjects) and Clinical Studies (contributing 200 subjects) were used to substantiate postoperative rankings distributions of SSQ-49 S1Q2, S1Q13, S3Q10 and S3Q15. These postoperative distributions were then used to estimate the proportion of cochlear implant recipients rating themselves as performing better than various preoperative ratings of the same questions. Subjects included were:
            </p>
            <ul className="moreinfo-ul">
              <li>Adults</li>
              <li>Had gradual presbycusis style hearing loss or sensory neural hearing loss with a high frequency roll-off</li>
              <li>Unilaterally implanted</li>
            </ul>

            <p>
              Table <MoreInfoTables table={tables.CategorizationBoundaries} request={requests.Index} /> records the postoperative distributions of the cochlear implant recipients ratings of on the four SSQ-49 questions (S1Q2, S1Q13, S3Q10 and S3Q15).      
            </p>
            
            <div>
              <MoreInfoTables table={tables.CategorizationBoundaries} request={requests.Title} />
              <MoreInfoTables table={tables.CategorizationBoundaries} />
            </div> 

            <p>
              Comparing to potential or hypothetical preoperative values or ratings on the four SSQ-49 questions, Table <MoreInfoTables table={tables.ProportionOfCIUsersRanking} request={requests.Index} /> records the proportion of cochlear implant recipients rating themselves as performing better.
            </p>                    

            <div>
              <MoreInfoTables table={tables.ProportionOfCIUsersRanking} request={requests.Title} />
              <MoreInfoTables table={tables.ProportionOfCIUsersRanking} />
            </div> 
          </div> 
          );
    }
}

export default InnerPostOperativeRankings;